interface SectionHeadingProps {
  id?: string;
  kicker: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
  actionIcon?: string;
}

export default function SectionHeading({
  id,
  kicker,
  title,
  desc,
  actionLabel,
  actionHref = "#collections",
  actionIcon = "ri-arrow-right-line",
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="mb-3 flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
          <span className="font-label text-xs font-medium tracking-[0.2em] text-primary-600">
            {kicker}
          </span>
        </div>
        <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
          {id ? (
            <a href={`#${id}`} className="cursor-pointer hover:text-primary-700">
              {title}
            </a>
          ) : (
            title
          )}
        </h2>
        {desc && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {desc}
          </p>
        )}
      </div>
      {actionLabel && (
        <a
          href={actionHref}
          className="group inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-4 py-2.5 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {actionLabel}
          <i className={`${actionIcon} w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-0.5`}></i>
        </a>
      )}
    </div>
  );
}